import {css} from 'lit';
export const styles = css`:host {
  --background-color: var(--contrast-light);
  --link-text: var(--dark-text);
  --padding: 16px;
  --member-size: 44px;
  --name-weight: 700px;
  --name-size: 15px;

  display: flex;
  align-items: center;
  padding-top: var(--padding);
  padding-bottom: var(--padding);
  background-color: var(--background-color);
}

:host([focus-within]) {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: var(--link-focus-outline-offset);
}

:host(:focus-within) {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: var(--link-focus-outline-offset);
}

xs-profile-avatar {
  --avatar-size: var(--member-size);
}

.info {
  flex: 1;
  margin-left: 8px;
  margin-right: 8px;
  min-width: 1px;
}

.info > * {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

.actions {
  display: flex;
  align-items: center;
}

.actions ::slotted(*:not(:first-child)) {
    margin-left: 8px !important;
  }

.name {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: var(--name-weight);
  font-size: var(--name-size);
}

.role,
slot[name='info'] {
  display: block;
  font-size: 14px;
  color: var(--dark-text-secondary);
}

slot[name='info']::slotted(*) {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
`;
export default styles;
